import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ad70254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TumiBackground" }
const _hoisted_2 = { class: "container pt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-8" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "YOUR PROJECTS")
], -1))
const _hoisted_5 = { class: "col-sm-12 col-md-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "TumiBack TumiCreate mt-5"
}
const _hoisted_8 = { class: "container pt-5 pb-5 mt-3 mb-3" }
const _hoisted_9 = { class: "container pt-5 pb-5" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-success" }, "Email confirmed"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "Email not confirmed")
], -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"TumiTitre rounded-top\" data-v-0ad70254><div class=\"row\" data-v-0ad70254><div class=\"col-sm-6 col-md-2\" data-v-0ad70254>Name</div><div class=\"col-sm-6 col-md-2\" data-v-0ad70254>Client</div><div class=\"col-sm-6 col-md-4\" data-v-0ad70254>Tiers</div><div class=\"col-sm-6 col-md-4\" data-v-0ad70254>ProjectLifeKey</div></div></div>", 1)
const _hoisted_16 = {
  key: 0,
  class: "text-center pt-3 pb-3 TumiBack"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-sm-6 col-md-2" }
const _hoisted_20 = { class: "col-sm-6 col-md-2" }
const _hoisted_21 = { class: "col-sm-6 col-md-4" }
const _hoisted_22 = {
  key: 0,
  class: "TumiBack"
}
const _hoisted_23 = {
  key: 0,
  class: "container pt-3 pb-3"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = {
  key: 1,
  class: "container pt-3 pb-3"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = ["disabled", "onClick"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavigationPortal = _resolveComponent("NavigationPortal")!
  const _component_NewProject = _resolveComponent("NewProject")!
  const _component_LoadProject = _resolveComponent("LoadProject")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_NavigationPortal, { class: "TumiMarginUp" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-secondary float-md-end",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.New && _ctx.New(...args)))
            }, "+ Create new project")
          ])
        ]),
        _hoisted_6
      ]),
      (_ctx.newProject)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_NewProject, { onCloseNewProject: _ctx.CloseNewProject }, null, 8, ["onCloseNewProject"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.projects)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : _createCommentVNode("", true),
        (_ctx.projects)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("ul", null, [
                _hoisted_15,
                (_ctx.projects.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, " You have no projects. "))
                  : _createCommentVNode("", true),
                (_ctx.projects.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.projects, (pr) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: pr.PROJECT_ID
                      }, [
                        _createElementVNode("li", {
                          onClick: ($event: any) => (_ctx.SelectProject(pr.PROJECT_ID))
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, _toDisplayString(pr.PROJECT_NAME), 1),
                            _createElementVNode("div", _hoisted_20, _toDisplayString(pr.PROJECT_NAMECLIENT), 1),
                            _createElementVNode("div", {
                              class: _normalizeClass({
                      'col-sm-6 col-md-4':'true',
                      'text-success': pr.PROJECT_EMAILCONFIRMED,
                      'text-danger': !pr.PROJECT_EMAILCONFIRMED})
                            }, _toDisplayString(pr.PROJECT_EMAILTIER), 3),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(pr.PROJECT_CODE), 1)
                          ])
                        ], 8, _hoisted_17),
                        (pr.PROJECT_ID == _ctx.activeLi)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              (pr.PROJECT_ACTIVATED)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _createTextVNode(" - The key linked to this project has been activated on " + _toDisplayString(_ctx.ParseDate(pr.PROJECT_ACTIVATED)) + ". ", 1),
                                    (pr.PROJECT_OBJECTED)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                          _hoisted_25,
                                          _createTextVNode("- The key linked to this project has been objected on " + _toDisplayString(_ctx.ParseDate(pr.PROJECT_OBJECTED)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (pr.PROJECT_DONE)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                          _hoisted_27,
                                          _createTextVNode("- The files linked to this project have been transferred on " + _toDisplayString(_ctx.ParseDate(pr.PROJECT_DONE)), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (!pr.PROJECT_ACTIVATED)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-danger float-end me-2 mb-2",
                                      onClick: ($event: any) => (_ctx.DeleteProject(pr.PROJECT_ID))
                                    }, "Delete", 8, _hoisted_29),
                                    _createElementVNode("button", {
                                      disabled: _ctx.spinSend,
                                      class: "btn btn-sm btn-secondary float-end me-2 mb-2",
                                      onClick: ($event: any) => (_ctx.SendCode(pr.PROJECT_ID))
                                    }, [
                                      (!_ctx.spinSend)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Send code to client"))
                                        : _createCommentVNode("", true),
                                      (_ctx.spinSend)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Code sent!"))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_30),
                                    (!pr.PROJECT_EMAILCONFIRMED)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          disabled: _ctx.spinConfirm,
                                          class: "btn btn-sm btn-secondary float-end me-2 mb-2",
                                          onClick: ($event: any) => (_ctx.SendConfirm(pr.PROJECT_ID))
                                        }, [
                                          (!_ctx.spinConfirm)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Ask confirmation of email of the follower again"))
                                            : _createCommentVNode("", true),
                                          (_ctx.spinConfirm)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Email sent!"))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_33))
                                      : _createCommentVNode("", true),
                                    _hoisted_36,
                                    _createVNode(_component_LoadProject, {
                                      id: _ctx.activeLi,
                                      onReload: _ctx.Reload
                                    }, null, 8, ["id", "onReload"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}